import { defineMessages } from 'react-intl';

export const messages: {
	extensionError: {
		id: string;
		description: string;
		defaultMessage: string;
	};
} = defineMessages({
	extensionError: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.extension-error',
		description: 'Error message to display when a form extension is missing its ID',
		defaultMessage:
			'We are unable to render this extension at this time. Please remove the extension from the form and try again.',
	},
});
